import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import clsx from "clsx";
import type { ComparacaoResumo, ResumoProps, SecaoResumo } from "./appResumoAlteracoes.types";

// ------------------------------- COMPONENTS ------------------------------
function ResumoSecao({ secao }: Readonly<{ readonly secao: SecaoResumo }>) {
	return (
		<section className="mb-3 overflow-hidden rounded-xl border bg-paper last:mb-0">
			<div className="flex items-center gap-2 border-b bg-accent-foreground px-3 py-1">
				{secao.icone ? (
					<FuseSvgIcon size={18} className="text-primary">
						{secao.icone}
					</FuseSvgIcon>
				) : (
					<span className="h-2 w-2 shrink-0 rounded-sm bg-primary" />
				)}
				<span className="text-xs font-bold uppercase text-foreground">{secao.titulo}</span>
			</div>
			<div
				className={clsx(
					"px-2 py-1",
					secao.colunas === 2 ? "grid grid-cols-1 gap-x-3 sm:grid-cols-2" : "flex flex-col gap-0.5",
				)}
			>
				{secao.tipo === "comparacoes" ? (
					<>
						{secao.itens.map((item) => (
							<ResumoComparacao key={item.id} item={item} />
						))}
						{secao.rodape}
					</>
				) : (
					secao.conteudo
				)}
			</div>
		</section>
	);
}

function ResumoComparacao({ item }: Readonly<{ readonly item: ComparacaoResumo }>) {
	const valorClassName = clsx(
		"inline-block min-w-0 max-w-full whitespace-normal rounded-md px-1.5 py-0.5 text-xs",
		item.quebrarTudo ? "break-all" : "break-words",
	);
	return (
		<div className="min-w-0 rounded-lg px-2 py-1 hover:bg-muted/50">
			<span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{item.label}</span>
			<div className="mt-1 flex min-w-0 flex-wrap items-center gap-1.5">
				{item.de === null ? null : (
					<>
						<span className={clsx(valorClassName, "bg-muted text-muted-foreground line-through")}>
							{item.de}
						</span>
						<FuseSvgIcon size={14} className="text-muted-foreground">
							lucide:arrow-right
						</FuseSvgIcon>
					</>
				)}
				<span className={clsx(valorClassName, "bg-primary/10 font-bold text-primary")}>{item.para}</span>
			</div>
		</div>
	);
}

// ------------------------------- COMPONENT -------------------------------
export default function AppResumoAlteracoes({ secoes, contagem, estadoVazio, className }: Readonly<ResumoProps>) {
	return (
		<>
			{contagem}
			<div className={clsx("min-h-0 flex-1 overflow-y-auto p-1", className)}>
				{estadoVazio}
				{secoes.map((secao) => (
					<ResumoSecao key={secao.id} secao={secao} />
				))}
			</div>
		</>
	);
}
